import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { BLUE } from '../../utils/colors';

const styles = {
  title: {
    display: 'inline-block',
    fontSize: '16px',
    fontWeight: '400'
  },
  label: {
    display: 'block',
    color: 'rgba(0,0,0,.86)',
    width: '100%',
    fontWeight: '400',
    textTransform: 'none'
  },
  disabledLabel: {
    display: 'block',
    color: 'rgba(0,0,0,.54)',
    width: '100%',
    fontWeight: '400',
    textTransform: 'none'
  },
  input: {
    marginRight: '0.5em'
  },
  cta: {
    display: 'block',
    fontSize: '12px',
    textAlign: 'center',
    color: '#fff',
    background: BLUE,
    width: '100%',
    padding: '8px 0 6px 0',
    position: 'absolute',
    textTransform: 'uppercase',
    bottom: '0px',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: BLUE,
    boxSizing: 'content-box',
    left: '-1px'
  },
  warningIcon: {
    color: '#fff',
    background: '#f0ad4e',
    width: '17px',
    height: '17px',
    display: 'inline-block',
    verticalAlign: 'top',
    margin: '20px 10px 0px -3px',
    borderRadius: '50%',
    position: 'relative'
  },
  warningIconInner: {
    position: 'absolute',
    top: '-6px',
    left: '7px'
  },
  production: {
    display: 'inline-block',
    width: '87%',
    fontSize: '92%',
    color: 'rgba(0, 0, 0, 0.57)',
    position: 'absolute',
    bottom: '59px'
  },
  toggle: {
    float: 'right',
    marginTop: '11px'
  }
};

class TenantEnvironmentForm extends Component {
  constructor(props) {
    super(props);
    this.state = { selected: props.environment };
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSelect(e) {
    this.setState({ selected: e.target.value });
  }

  handleSubmit(e) {
    e.preventDefault();

    const {
      handleClose,
      onSubmit,
      updating
    } = this.props;

    if (!updating) {
      onSubmit(this.state.selected);
      handleClose();
    }
  }

  render() {
    const { updating, handleClose } = this.props;
    const _submit = { ...styles.cta };

    if (updating) {
      _submit.background = 'rgb(245, 245, 245)';
      _submit.borderColor = 'rgb(245, 245, 245)';
      _submit.color = '#B6B7B9';
      _submit.cursor = 'default';
    }

    return (
      <div>
        <h5 style={styles.title}>Assign Environment Tag</h5>
        {handleClose && (
          <a style={styles.toggle} href="#" onClick={handleClose}>
            <i className="icon-budicon-471" />
          </a>
        )}
        <label style={styles.label}>
          <input
            disabled={updating}
            style={styles.input}
            type="radio"
            value="development"
            onChange={this.handleSelect}
            checked={this.state.selected === 'development'}
          />
          Development
        </label>
        <label style={styles.label}>
          <input
            disabled={updating}
            style={styles.input}
            type="radio"
            value="staging"
            onChange={this.handleSelect}
            checked={this.state.selected === 'staging'}
          />
          Staging
        </label>
        <label style={styles.label}>
          <input
            disabled={updating}
            style={styles.input}
            type="radio"
            value="production"
            onChange={this.handleSelect}
            checked={this.state.selected === 'production'}
          />
          Production
        </label>
        <p>
          <span style={styles.production}>
            For mixed use tenants select the higher environment. e.g. if you use
            a tenant for development and production select Production.
          </span>
        </p>
        <button style={_submit} onClick={this.handleSubmit}>
          Save Changes
        </button>
      </div>
    );
  }
}

TenantEnvironmentForm.propTypes = {
  handleClose: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool,
  ]),
  environment: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  updating: PropTypes.bool,
};

TenantEnvironmentForm.defaultProps = {
};

export default TenantEnvironmentForm;
